import { render } from "./PendingTicket.vue?vue&type=template&id=474a8604"
import script from "./PendingTicket.vue?vue&type=script&lang=js"
export * from "./PendingTicket.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klous/Documents/beye/src/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__